<!-- TEMPLATE -->
<template>
  <div>
    <list-all-customers v-if="viewAllPartners"></list-all-customers>
    <list-customers v-else></list-customers>
  </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import ListAllCustomers from '@/views/customers/listAllCustomers.vue';
  import ListCustomers from '@/views/customers/listCustomers.vue';

  @Component({
    components: {
      ListAllCustomers,
      ListCustomers,
    },
  })
  export default class List extends Vue {
    get viewAllPartners()  {
      if (
        this.$store.getters.getUser.organization
        &&
        this.$store.getters.getUser.organization.isProvider
        &&
        this.$store.getters.getUser.privileges.indexOf('view-partner') > -1
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
</script>

<!-- STYLE -->
<style lang='scss' scoped>

</style>
